import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import classes from './ResourceCell.module.css';

const resourceCell = (model) => {
    const toolTipList = model.data.UserTypes.map((s, index) => {
        return <div style={{ padding: '5px' }} key={index}>{s.UserAttributes.title}</div>;
    });
    let specialtyList = model.data.UserTypes.length !== 0 ? model.data.UserTypes[0].Usertype : '';
    if (model.data.UserTypes.length > 1) {
        specialtyList += ' (+' + (model.data.UserTypes.length - 1) + ')';
    }

    return (
        <div className={classes.ResourceCell}>
            <Tooltip
                title={
                    <span className={classes.Tooltip}>
                        {toolTipList}
                    </span>
                }
                placement="bottom"
            >
                <div>
                    <div className={classes.TechnicianName}>{model.data.fullName}</div>
                    <div className={classes.TechnicianSpecialities}>{specialtyList}</div>
                </div>
            </Tooltip>
        </div>
    );
};

export default resourceCell;
